import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import { Link } from "react-router-dom";
const CancellationPolicy = () => {
  return (
    <>
      <Header></Header>
      <div className="mainContent privacyPolicyWrap cancelPolicy">
        <div className="privacyBannerWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2>Flight Cancellation Policy </h2>
                <p>
                  <strong>UK and EU regulations</strong> (such as EC Regulation
                  261/2004) to ensure compliance
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="introductionWrap">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10">
                <h2>Flight Cancellation Policy (UK & EU)</h2>
                <p>
                  At <strong>Travasco</strong>, we aim to provide a smooth and
                  reliable travel booking experience. However, we understand
                  that unforeseen circumstances may lead to changes in your
                  travel plans. This <strong>Flight Cancellation Policy</strong>{" "}
                  outlines the conditions under which cancellations are handled
                  for flights booked through our platform, in compliance with UK
                  and EU regulations.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="cancelPolicyDataWrap">
          <div className="container">
            <div className="row">
              <div className="row justify-content-center">
                <div className="col-md-10">
                  <h2>1. Airline-Specific Policies</h2>
                  <p>
                    All flight bookings made via{" "}
                    <a href="travasco.com" target="_blank">
                      travasco.com
                    </a>{" "}
                    are subject to the{" "}
                    <strong>
                      cancellation policies of the respective airline
                    </strong>
                    . These policies may vary depending on:
                  </p>
                  <ul>
                    <li>Airline-specific terms and conditions</li>
                    <li>
                      Type of fare purchased (e.g., refundable, non-refundable,
                      economy, business)
                    </li>
                    <li>Flight route and class of service</li>
                  </ul>
                  <p>
                    We recommend reviewing the specific airline's terms before
                    confirming your booking.
                  </p>
                  <h2>2. Passenger-Initiated Cancellations</h2>
                  <p>
                    You may cancel your flight booking through your account
                    dashboard or by contacting our customer support team.
                  </p>
                  <h3>2.1 Refundable Tickets</h3>
                  <ul>
                    <li>
                      <strong>Eligible for a full or partial refund</strong> as
                      per the airline’s cancellation policy.
                    </li>
                    <li>
                      <strong>A service fee</strong> may apply, depending on the
                      airline and the fare.
                    </li>
                  </ul>
                  <h3>2.2 Non-Refundable Tickets</h3>
                  <ul>
                    <li>
                      Typically <strong> non-refundable.</strong>
                    </li>
                    <li>
                      However, some airlines may offer
                      <strong> travel credit</strong> or the option to rebook,
                      subject to fees and availability.
                    </li>
                  </ul>
                  <h3>2.3 Cancellation Deadlines</h3>
                  <ul>
                    <li>
                      <strong>At least 24 hours before departure</strong> for
                      most tickets. This may vary depending on the airline and
                      fare type.
                    </li>
                    <li>
                      If your booking was made
                      <strong>within 14 days of departure,</strong> you may have
                      a <strong>shorter cancellation window.</strong>
                    </li>
                  </ul>
                  <h2>
                    3. Cancellation Within 24 Hours of Booking (Cooling-off
                    Period)
                  </h2>
                  <p>
                    In accordance with{" "}
                    <strong>UK and EU consumer protection laws,</strong> if you
                    cancel your flight within{" "}
                    <strong>14 days of booking </strong> (and at least{" "}
                    <strong>7 days before departure</strong>), you may be
                    entitled for a <strong>full refund</strong> (depending on
                    the airlines cancellation rules), as long as the booking was
                    made more than <strong>14 days before departure.</strong>
                  </p>
                  <p>
                    This <strong>cooling-off period</strong> does not apply to
                    non-refundable tickets, or if the flight was booked within
                    14 days of departure.
                  </p>
                  <h2>
                    4. Flight Cancellations by Airlines (EU Regulation EC
                    261/2004)
                  </h2>
                  <p>
                    If the airline cancels your flight, you have the following
                    rights under <strong>EC Regulation 261/2004:</strong>
                  </p>
                  <ul>
                    <li>
                      <strong>Right to a refund</strong> for the full ticket
                      price, or
                    </li>
                    <li>
                      <strong>Right to rebook</strong> on the next available
                      flight at no additional cost.
                    </li>
                  </ul>
                  <p>In addition, you may be entitled to compensation if:</p>
                  <ul>
                    <li>
                      Your flight is cancelled within{" "}
                      <strong>14 days of departure.</strong>
                    </li>
                    <li>
                      The cancellation was not due to extraordinary
                      circumstances (e.g., bad weather, strikes, security
                      risks).
                    </li>
                  </ul>
                  <p>
                    The compensation amounts can vary depending on the flight
                    distance and the length of the delay caused by the
                    cancellation:
                  </p>
                  <ul>
                    <li>
                      <strong>€250 </strong> for flights up to 1,500 km.
                    </li>
                    <li>
                      <strong> €400 </strong> for intra-EU flights over 1,500 km
                      and other flights between 1,500–3,500 km.
                    </li>
                    <li>
                      <strong>€600</strong> for flights over 3,500 km.
                    </li>
                  </ul>
                  <p>
                    Please note that compensation rights are subject to specific
                    conditions. We will assist you in processing any claims as
                    per airline regulations.
                  </p>
                  <h2>5. Service Fees</h2>
                  <p>
                    In addition to airline penalties, <strong>Travasco</strong>{" "}
                    charges a <strong>service fee of £75</strong> for
                    cancellations or modifications. The exact fee will be
                    displayed before confirming any changes.
                  </p>
                  <h2>6. How to Cancel a Flight</h2>
                  <ul>
                    <li>
                      <strong>Online:</strong> Navigate to travasco.com and
                      click "Manage Bookings" {">"} "Cancel Booking".
                    </li>
                    <li>
                      <strong>Support: </strong> If you encounter issues, please
                      contact our Customer Service team via chat, email or phone
                      with your booking reference.
                    </li>
                  </ul>
                  <h2>7. Refund Processing Time</h2>
                  <p>
                    Refunds will be processed within{" "}
                    <strong>7 to 14 business days,</strong> depending on the
                    airline and the payment method. Please note that airlines
                    may take additional time to process refunds.
                  </p>
                  <h2>8. Exceptions to Cancellation</h2>
                  <p>
                    You may not be eligible for a refund in the following
                    situations:
                  </p>
                  <ul>
                    <li>
                      <strong>No-show passengers:</strong> If you fail to board
                      the flight without prior cancellation, no refund or
                      compensation is applicable.
                    </li>
                    <li>
                      <strong>Missed flight due to late arrival:</strong> If you
                      arrive after the check-in deadline or boarding has closed,
                      you will be responsible for any costs associated with
                      rebooking.
                    </li>
                  </ul>
                  <h2>9. Important Information for EU and UK Passengers</h2>
                  <ul>
                    <li>
                      <strong>Airlines must notify passengers</strong> of
                      cancellations or schedule changes at least{" "}
                      <strong>14 days prior to the flight</strong> to avoid
                      penalties under EU regulation.
                    </li>
                    <li>
                      If your flight is cancelled, we will support you in
                      pursuing compensation or alternative travel arrangements
                      in compliance with{" "}
                      <strong>EU Regulation EC 261/2004</strong> and{" "}
                      <strong>UK Consumer Law.</strong>
                    </li>
                  </ul>
                  <p>
                    For further assistance or if you have questions regarding
                    your cancellation request, please contact our Customer
                    Support Team at{" "}
                    <a href="mailto:info@travasco.com.">
                      info@travasco.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </>
  );
};
export default CancellationPolicy;
